import Home from './pages/Home.vue';
import Login from './pages/Login.vue';
import Register from './pages/Register.vue';
import Anderson from './pages/Anderson.vue';
import Suport from './pages/Suport.vue';

export const routes = [
    { path: '/', name: 'home', component: Home, title: 'Home', icon: 'home' },
    { path: "/login", name: "login", component: Login, showMenu: false },

    { path: "/register", name: "register", component: Register, showMenu: false },
    { path: "/anderson", name: "anderson", component: Anderson, showMenu: false },
    { path: "/suport", name: "suport", component: Suport, showMenu: false },


    { path: '*', component: Home }
];